export const CANVAS_ELEMENTS = "#outline-canvas, #pplr_canvas";
export const CANVAS_ELEMENTS_WRAPPER = "media-gallery:has(canvas)";
export const BOTTOM_LETTERS = ".pplr-bottom-letters";
export const BOTTOM_LETTERS_INPUT = ".pplr-bottom-letters input";
export const BOTTOM_LETTERS_WRAPPER_SELECTOR = ".pplr-bottom-letters.pplr-color-select";
export const SECONDARY_LETTERS = ".pplr-create-a-one-of-a-kind-hat input";
export const SECONDARY_LETTERS_WRAPPER_SELECTOR =
	".pplr-create-a-one-of-a-kind-hat.pplr-color-select";
export const THREED_LIFT_TEN = ".pplr-3d-lift-10";
export const THREED_LIFT_TEN_INPUT = ".pplr-3d-lift-10 input"; // Font Selection.

export const HOODBLOCK_LETTERS_SELECTOR =
	".pplr-wrapper.pplr-font-select > div > span.pplr-selecter-item.pplr_hood-blockletters";
export const HOODBLOCK_LETTERS_SELECTOR_NOT_MICROSCRIPT =
	".pplr-wrapper.pplr-font-select:not(.pplr-microscript-text) > div > span.pplr-selecter-item.pplr_hood-blockletters";
export const HOODSCRIPT_LETTERS_SELECTOR =
	".pplr-wrapper.pplr-font-select > div > span.pplr-selecter-item.pplr_hoodscript";
export const HOODSCRIPT_LETTERS_SELECTOR_NOT_MICROSCRIPT =
	".pplr-wrapper.pplr-font-select:not(.pplr-microscript-text) > div > span.pplr-selecter-item.pplr_hoodscript";
export const BUBBLE_LETTERS_SELECTOR =
	".pplr-wrapper.pplr-font-select > div > span.pplr-selecter-item.pplr_coopernouveau";
export const BUBBLE_LETTERS_SELECTOR_NOT_MICROSCRIPT =
	".pplr-wrapper.pplr-font-select:not(.pplr-microscript-text) > div > span.pplr-selecter-item.pplr_coopernouveau";
export const JOURNEY_LETTER_SELECTOR =
	".pplr-wrapper.pplr-font-select > div > span.pplr-selecter-item.pplr_thistails-regular";
export const JOURNEY_LETTER_SELECTOR_NOT_MICROSCRIPT =
	".pplr-wrapper.pplr-font-select:not(.pplr-microscript-text) > div > span.pplr-selecter-item.pplr_thistails-regular";
export const FORMOSA_LETTER_SELECTOR =
	".pplr-wrapper.pplr-font-select > div > span.pplr-selecter-item.pplr_chinesetakeaway";
export const FORMOSA_LETTER_SELECTOR_NOT_MICROSCRIPT =
	".pplr-wrapper.pplr-font-select:not(.pplr-microscript-text) > div > span.pplr-selecter-item.pplr_chinesetakeaway";
export const OLDE_LETTERS_SELECTOR =
	".pplr-wrapper.pplr-font-select > div > span.pplr-selecter-item.pplr_olde-regular-new";
export const NAME_GAME_LETTERS_SELECTOR =
	".pplr-wrapper.pplr-font-select.pplr-script-text > div > span.pplr-selecter-item.pplr_helvetica-roman";
export const MICRONAME_GAME_LETTERS_SELECTOR =
	".pplr-wrapper.pplr-font-select.pplr-microscript-text > div > span.pplr-selecter-item.pplr_helvetica-roman";
export const OLDE_LETTERS_SELECTOR_NOT_MICROSCRIPT =
	".pplr-wrapper.pplr-font-select:not(.pplr-microscript-text) > div > span.pplr-selecter-item.pplr_olde-regular-new";
export const BOTTOMS_UP_LETTERS_SELECTOR =
	".pplr-wrapper.pplr-font-select > div > span.pplr-selecter-item.pplr_bottomsup";
export const BOTTOMS_UP_LETTERS_SELECTOR_NOT_MICROSCRIPT =
	".pplr-wrapper.pplr-font-select:not(.pplr-microscript-text) > div > span.pplr-selecter-item.pplr_bottomsup";
export const PROSHOP_UP_LETTERS_SELECTOR_NOT_MICROSCRIPT =
	".pplr-wrapper.pplr-font-select:not(.pplr-microscript-text) > div > span.pplr-selecter-item.pplr_almamatersolid";
export const PROSHOP_LETTERS_SELECTOR =
	".pplr-wrapper.pplr-font-select > div > span.pplr-selecter-item.pplr_almamatersolid";

export const NEUTRA_UP_LETTERS_SELECTOR_NOT_MICROSCRIPT =
	".pplr-wrapper.pplr-font-select:not(.pplr-microscript-text) > div > span.pplr-selecter-item.pplr_neutra";
export const NEUTRA_LETTERS_SELECTOR =
	".pplr-wrapper.pplr-font-select > div > span.pplr-selecter-item.pplr_neutra";

export const BUBBLE_LETTERS_MICROSCRIPT_OPTION =
	".pplr-font-select.pplr-microscript-text .pplr-selecter-options .pplr_coopernouveau";
export const BUBBLE_LETTERS_MICROBEANIE_OPTION =
	".pplr-font-select.pplr-microbeanie-text .pplr-selecter-options .pplr_coopernouveau";
export const JOURNEY_LETTERS_MICROSCRIPT_OPTION =
	".pplr-font-select.pplr-microscript-text .pplr-selecter-options .pplr_thistails-regular";
export const BOTTOMSUP_LETTERS_MICROSCRIPT_OPTION =
	".pplr-font-select.pplr-microscript-text .pplr-selecter-options .pplr_bottomsup";
export const PROSHOP_LETTERS_MICROSCRIPT_OPTION =
	".pplr-font-select.pplr-microscript-text .pplr-selecter-options .pplr_almamatersolid";
export const JOURNEY_LETTERS_MICROBEANIE_OPTION =
	".pplr-font-select.pplr-microbeanie-text .pplr-selecter-options .pplr_thistails-regular";
export const BOTTOMSUP_LETTERS_MICROBEANIE_OPTION =
	".pplr-font-select.pplr-microbeanie-text .pplr-selecter-options .pplr_bottomsup";
export const PROPSHOP_LETTERS_MICROBEANIE_OPTION =
	".pplr-font-select.pplr-microbeanie-text .pplr-selecter-options .pplr_almamatersolid";

export const FONT_SELECT_SELECTOR =
	".pplr-font-select:not(.pplr-microscript-text) .pplr-selecter-options  > span";
export const OLDE_LETTERS_MICROSCRIPT_OPTION =
	".pplr-font-select.pplr-microscript-text .pplr-selecter-options .pplr_olde-regular-new";
(".pplr-font-select.pplr-microscript-text .pplr-selecter-options .pplr_olde-regular-new");

export const MICROSCRIPT_TEXT = ".pplr-microscript-text";
export const MICROSCRIPT_TEXT_INPUT = ".pplr-microscript-text input";
export const MICRO = ".pplr-micro";
export const MICRO_CHECKBOX = ".pplr-checkbox.pplr-micro input";
export const KNIT_BEANIE_TEXT = ".pplr-knit-beanie-text"; // Knit Beanie Font Selection.

export const KNITBEANIE_SCRIPT_LETTERS_SELECTOR =
	".pplr-wrapper.pplr-font-select.pplr-knit-beanie-text > div > span.pplr-selecter-item.pplr_hoodscript";
export const KNITBEANIE_BLOCK_LETTERS_SELECTOR =
	".pplr-wrapper.pplr-font-select.pplr-knit-beanie-text > div > span.pplr-selecter-item.pplr_hood-blockletters";
export const KNITBEANIE_BUBBLE_LETTERS_SELECTOR =
	".pplr-wrapper.pplr-font-select.pplr-knit-beanie-text > div > span.pplr-selecter-item.pplr_coopernouveau";
export const KNITBEANIE_JOURNEY_LETTERS_SELECTOR =
	".pplr-wrapper.pplr-font-select.pplr-knit-beanie-text > div > span.pplr-selecter-item.pplr_thistails-regular";
export const KNITBEANIE_FORMOSA_LETTERS_SELECTOR =
	".pplr-wrapper.pplr-font-select.pplr-knit-beanie-text > div > span.pplr-selecter-item.pplr_chinesetakeaway";
export const KNITBEANIE_OLDE_LETTERS_SELECTOR =
	".pplr-wrapper.pplr-font-select.pplr-knit-beanie-text > div > span.pplr-selecter-item.pplr_olde-regular-new";
export const KNITBEANIE_BOTTOMSUP_LETTERS_SELECTOR =
	".pplr-wrapper.pplr-font-select.pplr-knit-beanie-text > div > span.pplr-selecter-item.pplr_bottomsup";
export const KNITBEANIE_PROSHOP_LETTERS_SELECTOR =
	".pplr-wrapper.pplr-font-select.pplr-knit-beanie-text > div > span.pplr-selecter-item.pplr_almamatersolidbottomsup";

export const MICROKNITBEANIE_SCRIPT_LETTERS_SELECTOR =
	".pplr-wrapper.pplr-font-select.pplr-microbeanie-text > div > span.pplr-selecter-item.pplr_hoodscript";

export const MICROKNITBEANIE_BLOCK_LETTERS_SELECTOR =
	".pplr-wrapper.pplr-font-select.pplr-microbeanie-text > div > span.pplr-selecter-item.pplr_hood-blockletters";

export const MICROKNITBEANIE_FORMOSA_LETTERS_SELECTOR =
	".pplr-wrapper.pplr-font-select.pplr-microbeanie-text > div > span.pplr-selecter-item.pplr_chinesetakeaway";

export const MICROKNITBEANIE_OLDE_LETTERS_SELECTOR =
	".pplr-wrapper.pplr-font-select.pplr-microbeanie-text > div > span.pplr-selecter-item.pplr_olde-regular-new"; // Micro Fonts

export const MICROHOODBLOCK_LETTERS_SELECTOR =
	".pplr-wrapper.pplr-font-select.pplr-microscript-text > div > span.pplr-selecter-item.pplr_hood-blockletters";
export const MICROHOODSCRIPT_LETTERS_SELECTOR =
	".pplr-wrapper.pplr-font-select.pplr-microscript-text > div > span.pplr-selecter-item.pplr_hoodscript";
export const MICROFORMOSA_LETTER_SELECTOR =
	".pplr-wrapper.pplr-font-select.pplr-microscript-text > div > span.pplr-selecter-item.pplr_chinesetakeaway";
export const MICRONEUTRA_LETTERS_SELECTOR =
	".pplr-wrapper.pplr-font-select.pplr-microscript-text > div > span.pplr-selecter-item.pplr_neutra";
export const CHAINSTITCH = ".pplr-chain-stitch-20";
export const CHAINSTITCH_INPUT = ".pplr-chain-stitch-20 input";
export const MICRO_BEANIE_TEXT = ".pplr-microbeanie-text";
export const MULTILINE_TEXT = ".product-personalizer > .pplr-multiline";
export const MULTILINE_TEXTAREA = ".pplr-multiline textarea";
export const OUTLINE_TEXT = ".pplr-text.pplr-outline .pplr_text";
export const OUTLINE_WRAPPER_SELECTOR = ".pplr-wrapper.mcolor.pplr-color-select.pplr-outline";
export const SCRIPT_TEXT = ".pplr-script-text";
export const SCRIPT_TEXT_INPUT = ".pplr-script-text input";
